'use client'

import { useSyncExternalStore } from 'react'

const subscribe = (callback: () => void) => {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const handlePopState = () => callback()

  const observer = new MutationObserver(() => {
    callback()
  })

  window.addEventListener('popstate', handlePopState)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })

  return () => {
    window.removeEventListener('popstate', handlePopState)
    observer.disconnect()
  }
}

const getSnapshot = () =>
  typeof window !== 'undefined' ? window.location.search : ''

export function useSearchParams() {
  return useSyncExternalStore(subscribe, getSnapshot, () => '')
}
